import { useState } from "react";
import { useMutation } from "@tanstack/react-query";

interface LookupResult {
  reference: string;
  status: string;
  checkin_date: string;
  checkout_date: string;
  nights: number;
  total_cents: number;
  self_checkin?: {
    bank_account_holder: string;
    bank_name: string;
    key_box_code: string | null;
  };
}

const STATUS_LABEL_MS: Record<string, string> = {
  DRAFT: "Draf",
  PENDING_PAYMENT: "Menunggu Pembayaran",
  PAYMENT_REVIEW: "Pembayaran Sedang Disemak",
  CONFIRMED: "Disahkan",
  CHECKED_IN: "Sudah Check-in",
  CHECKED_OUT: "Sudah Check-out",
  CANCELLED: "Dibatalkan",
  EXPIRED: "Tamat Tempoh",
  NO_SHOW: "Tidak Hadir",
  REFUNDED: "Dipulangkan",
};

export default function Semakan() {
  const [reference, setReference] = useState("");
  const [phone, setPhone] = useState("");

  const lookup = useMutation({
    mutationFn: async () => {
      const res = await fetch("/api/v1/lookup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ reference, phone }),
      });
      const data = (await res.json()) as LookupResult & { error?: string };

      if (!res.ok) throw new Error(data.error ?? "Tempahan tidak dijumpai");
      return data;
    },
  });

  return (
    <div className="max-w-lg mx-auto px-6 py-10">
      <h1 className="text-2xl font-bold text-sea-700 mb-6">Semak Status Tempahan</h1>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          lookup.mutate();
        }}
        className="bg-white rounded-xl shadow-sm p-6 space-y-4 mb-6"
      >
        <div>
          <label className="block text-sm font-medium mb-1">Nombor Rujukan</label>
          <input
            value={reference}
            onChange={(e) => setReference(e.target.value)}
            placeholder="RPH-202610-ABCDE"
            className="w-full border rounded-lg px-3 py-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">No. Telefon</label>
          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="012-3456789"
            className="w-full border rounded-lg px-3 py-2"
          />
        </div>
        <button
          type="submit"
          disabled={lookup.isPending}
          className="w-full bg-sea-500 text-white rounded-lg py-3 font-medium hover:bg-sea-600 transition disabled:opacity-50"
        >
          {lookup.isPending ? "Menyemak..." : "Semak Status"}
        </button>
      </form>

      {lookup.isError && (
        <p className="text-red-600 text-sm text-center">{(lookup.error as Error).message}</p>
      )}

      {lookup.data && (
        <div className="bg-white rounded-xl shadow-sm p-6 space-y-3 text-sm">
          <p>
            <strong>Status:</strong> {STATUS_LABEL_MS[lookup.data.status] ?? lookup.data.status}
          </p>
          <p>
            <strong>Tarikh:</strong> {lookup.data.checkin_date} — {lookup.data.checkout_date} ({lookup.data.nights} malam)
          </p>
          <p>
            <strong>Jumlah:</strong> RM{(lookup.data.total_cents / 100).toFixed(2)}
          </p>

          {lookup.data.self_checkin ? (
            <div className="border-t pt-3 mt-3 space-y-1">
              <p className="font-medium text-sea-700">Maklumat Self Check-in</p>
              <p>Kod Key Box: <span className="font-mono font-bold">{lookup.data.self_checkin.key_box_code ?? "Akan dihantar tidak lama lagi"}</span></p>
              <p className="text-xs text-sea-500">
                Jika anda memilih bank in, sila hubungi kami melalui WhatsApp untuk butiran akaun.
              </p>
            </div>
          ) : (
            <p className="text-sea-500 text-xs">
              Butiran self check-in akan dipaparkan di sini sebaik sahaja pembayaran anda disahkan.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
